var _g, _ellipse, _g2, _ellipse2, _g3, _ellipse3, _g4, _ellipse4, _g5, _ellipse5, _g6, _ellipse6, _g7, _ellipse7, _g8, _circle, _g9, _circle2, _g10, _ellipse8, _g11, _ellipse9, _g12, _ellipse10, _g13, _ellipse11, _g14, _ellipse12, _g15, _ellipse13, _g16, _ellipse14, _g17, _ellipse15, _g18, _circle3, _g19, _circle4, _g20, _ellipse16, _g21, _mask, _path, _path2, _g22, _mask2, _path3, _path4, _g23, _ellipse17, _g24, _circle5, _g25, _circle6, _g26, _circle7, _g27, _circle8, _g28, _circle9, _g29, _circle10, _g30, _circle11, _g31, _ellipse18, _g32, _circle12, _g33, _circle13, _g34, _circle14, _g35, _circle15, _g36, _circle16, _g37, _circle17, _g38, _circle18, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g39, _circle19, _g40, _circle20, _g41, _circle21, _g42, _circle22, _circle23, _g43, _circle24, _g44, _circle25, _circle26, _g45, _circle27, _g46, _g47, _circle28, _path13, _path14, _path15, _g48, _ellipse19, _g49, _ellipse20, _g50, _circle29, _g51, _circle30, _circle31, _circle32, _g52, _ellipse21, _g53, _circle33, _g54, _circle34, _g55, _circle35, _g56, _circle36, _g57, _circle37, _g58, _ellipse22, _g59, _ellipse23, _ellipse24, _g60, _ellipse25, _g61, _circle38, _g62, _circle39, _g63, _g64, _circle40, _g65, _circle41, _g66, _circle42, _circle43, _g67, _circle44, _g68, _ellipse26, _mask3, _path16, _path17, _g69, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g70, _path25, _path26, _g71, _path27, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 505,
    height: 300,
    viewBox: "0 0 505 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_2615_299)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.75268,
    cy: 0.753723,
    rx: 0.75268,
    ry: 0.753723,
    transform: "matrix(-0.149655 -0.988738 0.988802 -0.149231 53.6967 41.5801)",
    fill: "#76FFD5"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 0.75268,
    cy: 0.753723,
    rx: 0.75268,
    ry: 0.753723,
    transform: "matrix(-0.149655 -0.988738 0.988802 -0.149231 53.6967 41.5801)",
    fill: "url(#paint0_radial_2615_299)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_2615_299)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.37634,
    cy: 0.376862,
    rx: 0.37634,
    ry: 0.376862,
    transform: "matrix(-0.149655 -0.988738 0.988802 -0.149231 24.9607 7.85645)",
    fill: "#76FFD5"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 0.37634,
    cy: 0.376862,
    rx: 0.37634,
    ry: 0.376862,
    transform: "matrix(-0.149655 -0.988738 0.988802 -0.149231 24.9607 7.85645)",
    fill: "url(#paint1_radial_2615_299)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_f_2615_299)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.37634,
    cy: 0.376862,
    rx: 0.37634,
    ry: 0.376862,
    transform: "matrix(-0.149655 -0.988738 0.988802 -0.149231 45.0311 24.6191)",
    fill: "#76FFD5"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 0.37634,
    cy: 0.376862,
    rx: 0.37634,
    ry: 0.376862,
    transform: "matrix(-0.149655 -0.988738 0.988802 -0.149231 45.0311 24.6191)",
    fill: "url(#paint2_radial_2615_299)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter3_f_2615_299)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.13035,
    cy: 1.12926,
    rx: 1.13035,
    ry: 1.12926,
    transform: "matrix(0.912923 0.408131 -0.409118 0.912481 37.7072 104.204)",
    fill: "#76FFD5"
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1.13035,
    cy: 1.12926,
    rx: 1.13035,
    ry: 1.12926,
    transform: "matrix(0.912923 0.408131 -0.409118 0.912481 37.7072 104.204)",
    fill: "url(#paint3_radial_2615_299)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter4_f_2615_299)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.753566,
    cy: 0.752838,
    rx: 0.753566,
    ry: 0.752838,
    transform: "matrix(0.912923 0.408131 -0.409118 0.912481 53.0326 92.5225)",
    fill: "#76FFD5"
  }))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 0.753566,
    cy: 0.752838,
    rx: 0.753566,
    ry: 0.752838,
    transform: "matrix(0.912923 0.408131 -0.409118 0.912481 53.0326 92.5225)",
    fill: "url(#paint4_radial_2615_299)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter5_f_2615_299)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.753566,
    cy: 0.752838,
    rx: 0.753566,
    ry: 0.752838,
    transform: "matrix(0.912923 0.408131 -0.409118 0.912481 49.9575 130.297)",
    fill: "#76FFD5"
  }))), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 0.753566,
    cy: 0.752838,
    rx: 0.753566,
    ry: 0.752838,
    transform: "matrix(0.912923 0.408131 -0.409118 0.912481 49.9575 130.297)",
    fill: "url(#paint5_radial_2615_299)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter6_f_2615_299)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.753566,
    cy: 0.752838,
    rx: 0.753566,
    ry: 0.752838,
    transform: "matrix(0.912923 0.408131 -0.409118 0.912481 19.616 115.083)",
    fill: "#76FFD5"
  }))), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 0.753566,
    cy: 0.752838,
    rx: 0.753566,
    ry: 0.752838,
    transform: "matrix(0.912923 0.408131 -0.409118 0.912481 19.616 115.083)",
    fill: "url(#paint6_radial_2615_299)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter7_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.376328,
    cy: 0.376328,
    r: 0.376328,
    transform: "matrix(0.912923 0.408131 -0.409118 0.912481 59.2761 104.385)",
    fill: "#76FFD5"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 0.376328,
    cy: 0.376328,
    r: 0.376328,
    transform: "matrix(0.912923 0.408131 -0.409118 0.912481 59.2761 104.385)",
    fill: "url(#paint7_radial_2615_299)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter8_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.376328,
    cy: 0.376328,
    r: 0.376328,
    transform: "matrix(0.912923 0.408131 -0.409118 0.912481 38.5908 116.969)",
    fill: "#76FFD5"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 0.376328,
    cy: 0.376328,
    r: 0.376328,
    transform: "matrix(0.912923 0.408131 -0.409118 0.912481 38.5908 116.969)",
    fill: "url(#paint8_radial_2615_299)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter9_f_2615_299)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.753566,
    cy: 0.752838,
    rx: 0.753566,
    ry: 0.752838,
    transform: "matrix(0.912923 0.408131 -0.409118 0.912481 65.0472 178.237)",
    fill: "#76FFD5"
  }))), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 0.753566,
    cy: 0.752838,
    rx: 0.753566,
    ry: 0.752838,
    transform: "matrix(0.912923 0.408131 -0.409118 0.912481 65.0472 178.237)",
    fill: "url(#paint9_radial_2615_299)"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter10_f_2615_299)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.75268,
    cy: 0.753723,
    rx: 0.75268,
    ry: 0.753723,
    transform: "matrix(-0.149655 -0.988738 0.988802 -0.149231 452.274 39.5801)",
    fill: "#76FFD5"
  }))), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 0.75268,
    cy: 0.753723,
    rx: 0.75268,
    ry: 0.753723,
    transform: "matrix(-0.149655 -0.988738 0.988802 -0.149231 452.274 39.5801)",
    fill: "url(#paint10_radial_2615_299)"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter11_f_2615_299)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.37634,
    cy: 0.376862,
    rx: 0.37634,
    ry: 0.376862,
    transform: "matrix(-0.149655 -0.988738 0.988802 -0.149231 423.538 5.85645)",
    fill: "#76FFD5"
  }))), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 0.37634,
    cy: 0.376862,
    rx: 0.37634,
    ry: 0.376862,
    transform: "matrix(-0.149655 -0.988738 0.988802 -0.149231 423.538 5.85645)",
    fill: "url(#paint11_radial_2615_299)"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter12_f_2615_299)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.37634,
    cy: 0.376862,
    rx: 0.37634,
    ry: 0.376862,
    transform: "matrix(-0.149655 -0.988738 0.988802 -0.149231 443.609 22.6191)",
    fill: "#76FFD5"
  }))), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 0.37634,
    cy: 0.376862,
    rx: 0.37634,
    ry: 0.376862,
    transform: "matrix(-0.149655 -0.988738 0.988802 -0.149231 443.609 22.6191)",
    fill: "url(#paint12_radial_2615_299)"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter13_f_2615_299)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.13035,
    cy: 1.12926,
    rx: 1.13035,
    ry: 1.12926,
    transform: "matrix(0.912923 0.408131 -0.409118 0.912481 436.285 102.204)",
    fill: "#76FFD5"
  }))), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 1.13035,
    cy: 1.12926,
    rx: 1.13035,
    ry: 1.12926,
    transform: "matrix(0.912923 0.408131 -0.409118 0.912481 436.285 102.204)",
    fill: "url(#paint13_radial_2615_299)"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter14_f_2615_299)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.753566,
    cy: 0.752838,
    rx: 0.753566,
    ry: 0.752838,
    transform: "matrix(0.912923 0.408131 -0.409118 0.912481 451.61 90.5225)",
    fill: "#76FFD5"
  }))), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 0.753566,
    cy: 0.752838,
    rx: 0.753566,
    ry: 0.752838,
    transform: "matrix(0.912923 0.408131 -0.409118 0.912481 451.61 90.5225)",
    fill: "url(#paint14_radial_2615_299)"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter15_f_2615_299)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.753566,
    cy: 0.752838,
    rx: 0.753566,
    ry: 0.752838,
    transform: "matrix(0.912923 0.408131 -0.409118 0.912481 448.535 128.297)",
    fill: "#76FFD5"
  }))), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 0.753566,
    cy: 0.752838,
    rx: 0.753566,
    ry: 0.752838,
    transform: "matrix(0.912923 0.408131 -0.409118 0.912481 448.535 128.297)",
    fill: "url(#paint15_radial_2615_299)"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter16_f_2615_299)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.753566,
    cy: 0.752838,
    rx: 0.753566,
    ry: 0.752838,
    transform: "matrix(0.912923 0.408131 -0.409118 0.912481 418.193 113.083)",
    fill: "#76FFD5"
  }))), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 0.753566,
    cy: 0.752838,
    rx: 0.753566,
    ry: 0.752838,
    transform: "matrix(0.912923 0.408131 -0.409118 0.912481 418.193 113.083)",
    fill: "url(#paint16_radial_2615_299)"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter17_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.376328,
    cy: 0.376328,
    r: 0.376328,
    transform: "matrix(0.912923 0.408131 -0.409118 0.912481 457.854 102.385)",
    fill: "#76FFD5"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 0.376328,
    cy: 0.376328,
    r: 0.376328,
    transform: "matrix(0.912923 0.408131 -0.409118 0.912481 457.854 102.385)",
    fill: "url(#paint17_radial_2615_299)"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter18_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.376328,
    cy: 0.376328,
    r: 0.376328,
    transform: "matrix(0.912923 0.408131 -0.409118 0.912481 437.168 114.969)",
    fill: "#76FFD5"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 0.376328,
    cy: 0.376328,
    r: 0.376328,
    transform: "matrix(0.912923 0.408131 -0.409118 0.912481 437.168 114.969)",
    fill: "url(#paint18_radial_2615_299)"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter19_f_2615_299)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.753566,
    cy: 0.752838,
    rx: 0.753566,
    ry: 0.752838,
    transform: "matrix(0.912923 0.408131 -0.409118 0.912481 463.624 176.237)",
    fill: "#76FFD5"
  }))), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 0.753566,
    cy: 0.752838,
    rx: 0.753566,
    ry: 0.752838,
    transform: "matrix(0.912923 0.408131 -0.409118 0.912481 463.624 176.237)",
    fill: "url(#paint19_radial_2615_299)"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_d_2615_299)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 270.545,
    height: 58.0037,
    rx: 9,
    transform: "matrix(0.977767 0.209695 -0.210277 0.977642 124.332 105)",
    fill: "url(#paint20_linear_2615_299)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.383745,
    y: 0.593668,
    width: 269.545,
    height: 57.0037,
    rx: 8.5,
    transform: "matrix(0.977767 0.209695 -0.210277 0.977642 124.465 104.933)",
    stroke: "url(#paint21_linear_2615_299)"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-43-inside-1_2615_299",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.734 108.918C104.779 104.058 109.566 100.964 114.426 102.006L379.634 158.884C384.494 159.926 387.587 164.71 386.542 169.57L382.336 189.125L99.5277 128.473L103.734 108.918Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.734 108.918C104.779 104.058 109.566 100.964 114.426 102.006L379.634 158.884C384.494 159.926 387.587 164.71 386.542 169.57L382.336 189.125L99.5277 128.473L103.734 108.918Z",
    fill: "url(#paint22_linear_2615_299)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.734 108.918C104.895 103.519 110.214 100.08 115.614 101.238L378.867 157.697C384.267 158.855 387.703 164.171 386.542 169.57C387.471 165.25 384.284 160.904 379.424 159.861L114.216 102.984C109.356 101.942 104.663 104.598 103.734 108.918ZM382.336 189.125L99.5277 128.473L382.336 189.125ZM99.5277 128.473L105.626 100.119L99.5277 128.473ZM388.434 160.771L382.336 189.125L388.434 160.771Z",
    fill: "url(#paint23_linear_2615_299)",
    mask: "url(#path-43-inside-1_2615_299)"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_d_2615_299)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 318.555,
    height: 71.4371,
    rx: 9,
    transform: "matrix(0.998781 -0.0493677 0.0468396 0.998902 81.4113 66.5923)",
    fill: "url(#paint24_linear_2615_299)"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-46-inside-2_2615_299",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.8362 75.5824C81.6033 70.6173 85.4391 66.3934 90.4036 66.148L390.589 51.3104C395.554 51.065 399.767 54.8911 400 59.8562L401.251 86.5454L83.0877 102.272L81.8362 75.5824Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8362 75.5824C81.6033 70.6173 85.4391 66.3934 90.4036 66.148L390.589 51.3104C395.554 51.065 399.767 54.8911 400 59.8562L401.251 86.5454L83.0877 102.272L81.8362 75.5824Z",
    fill: "url(#paint25_linear_2615_299)",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8362 75.5824C81.5775 70.0656 85.8395 65.3724 91.3556 65.0997L389.544 50.3609C395.06 50.0882 399.741 54.3394 400 59.8562C399.793 55.4428 395.601 52.0639 390.636 52.3093L90.4505 67.1469C85.486 67.3923 81.6292 71.169 81.8362 75.5824ZM401.251 86.5454L83.0877 102.272L401.251 86.5454ZM83.0877 102.272L81.4146 66.5923L83.0877 102.272ZM399.578 50.8661L401.251 86.5454L399.578 50.8661Z",
    fill: "url(#paint26_linear_2615_299)",
    mask: "url(#path-46-inside-2_2615_299)"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_f_2615_299)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.557496,
    cy: 0.556811,
    rx: 0.557496,
    ry: 0.556811,
    transform: "matrix(-0.961299 0.275507 -0.276246 -0.961087 150.015 260.562)",
    fill: "#76FFD5"
  }))), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.557496,
    cy: 0.556811,
    rx: 0.557496,
    ry: 0.556811,
    transform: "matrix(-0.961299 0.275507 -0.276246 -0.961087 150.015 260.562)",
    fill: "url(#paint27_radial_2615_299)"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.371167,
    cy: 0.371167,
    r: 0.371167,
    transform: "matrix(-0.961299 0.275507 -0.276246 -0.961087 144.817 269.388)",
    fill: "#76FFD5"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.371167,
    cy: 0.371167,
    r: 0.371167,
    transform: "matrix(-0.961299 0.275507 -0.276246 -0.961087 144.817 269.388)",
    fill: "url(#paint28_radial_2615_299)"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.371167,
    cy: 0.371167,
    r: 0.371167,
    transform: "matrix(-0.961299 0.275507 -0.276246 -0.961087 137.09 254.612)",
    fill: "#76FFD5"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.371167,
    cy: 0.371167,
    r: 0.371167,
    transform: "matrix(-0.961299 0.275507 -0.276246 -0.961087 137.09 254.612)",
    fill: "url(#paint29_radial_2615_299)"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.371167,
    cy: 0.371167,
    r: 0.371167,
    transform: "matrix(-0.961299 0.275507 -0.276246 -0.961087 153.372 250.717)",
    fill: "#76FFD5"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.371167,
    cy: 0.371167,
    r: 0.371167,
    transform: "matrix(-0.961299 0.275507 -0.276246 -0.961087 153.372 250.717)",
    fill: "url(#paint30_radial_2615_299)"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.185583,
    cy: 0.185583,
    r: 0.185583,
    transform: "matrix(-0.961299 0.275507 -0.276246 -0.961087 138.688 266.897)",
    fill: "#76FFD5"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.185583,
    cy: 0.185583,
    r: 0.185583,
    transform: "matrix(-0.961299 0.275507 -0.276246 -0.961087 138.688 266.897)",
    fill: "url(#paint31_radial_2615_299)"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.185583,
    cy: 0.185583,
    r: 0.185583,
    transform: "matrix(-0.961299 0.275507 -0.276246 -0.961087 145.618 256.029)",
    fill: "#76FFD5"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.185583,
    cy: 0.185583,
    r: 0.185583,
    transform: "matrix(-0.961299 0.275507 -0.276246 -0.961087 145.618 256.029)",
    fill: "url(#paint32_radial_2615_299)"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.394749,
    cy: 0.394749,
    r: 0.394749,
    transform: "matrix(0.742795 0.669519 -0.670589 0.741829 146.124 292.58)",
    fill: "#76FFD5"
  }))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.394749,
    cy: 0.394749,
    r: 0.394749,
    transform: "matrix(0.742795 0.669519 -0.670589 0.741829 146.124 292.58)",
    fill: "url(#paint33_radial_2615_299)"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.394749,
    cy: 0.394749,
    r: 0.394749,
    transform: "matrix(0.742795 0.669519 -0.670589 0.741829 150.606 281.729)",
    fill: "#76FFD5"
  }))), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.394749,
    cy: 0.394749,
    r: 0.394749,
    transform: "matrix(0.742795 0.669519 -0.670589 0.741829 150.606 281.729)",
    fill: "url(#paint34_radial_2615_299)"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_f_2615_299)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.557496,
    cy: 0.556811,
    rx: 0.557496,
    ry: 0.556811,
    transform: "matrix(-0.961299 0.275507 -0.276246 -0.961087 367.329 261.562)",
    fill: "#76FFD5"
  }))), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.557496,
    cy: 0.556811,
    rx: 0.557496,
    ry: 0.556811,
    transform: "matrix(-0.961299 0.275507 -0.276246 -0.961087 367.329 261.562)",
    fill: "url(#paint35_radial_2615_299)"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.371167,
    cy: 0.371167,
    r: 0.371167,
    transform: "matrix(-0.961299 0.275507 -0.276246 -0.961087 362.132 270.388)",
    fill: "#76FFD5"
  }))), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.371167,
    cy: 0.371167,
    r: 0.371167,
    transform: "matrix(-0.961299 0.275507 -0.276246 -0.961087 362.132 270.388)",
    fill: "url(#paint36_radial_2615_299)"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter32_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.371167,
    cy: 0.371167,
    r: 0.371167,
    transform: "matrix(-0.961299 0.275507 -0.276246 -0.961087 354.405 255.612)",
    fill: "#76FFD5"
  }))), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.371167,
    cy: 0.371167,
    r: 0.371167,
    transform: "matrix(-0.961299 0.275507 -0.276246 -0.961087 354.405 255.612)",
    fill: "url(#paint37_radial_2615_299)"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter33_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.371167,
    cy: 0.371167,
    r: 0.371167,
    transform: "matrix(-0.961299 0.275507 -0.276246 -0.961087 370.687 251.717)",
    fill: "#76FFD5"
  }))), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.371167,
    cy: 0.371167,
    r: 0.371167,
    transform: "matrix(-0.961299 0.275507 -0.276246 -0.961087 370.687 251.717)",
    fill: "url(#paint38_radial_2615_299)"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter34_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.185583,
    cy: 0.185583,
    r: 0.185583,
    transform: "matrix(-0.961299 0.275507 -0.276246 -0.961087 356.002 267.897)",
    fill: "#76FFD5"
  }))), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.185583,
    cy: 0.185583,
    r: 0.185583,
    transform: "matrix(-0.961299 0.275507 -0.276246 -0.961087 356.002 267.897)",
    fill: "url(#paint39_radial_2615_299)"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter35_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.185583,
    cy: 0.185583,
    r: 0.185583,
    transform: "matrix(-0.961299 0.275507 -0.276246 -0.961087 362.933 257.029)",
    fill: "#76FFD5"
  }))), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.185583,
    cy: 0.185583,
    r: 0.185583,
    transform: "matrix(-0.961299 0.275507 -0.276246 -0.961087 362.933 257.029)",
    fill: "url(#paint40_radial_2615_299)"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter36_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.394749,
    cy: 0.394749,
    r: 0.394749,
    transform: "matrix(0.742795 0.669519 -0.670589 0.741829 363.438 293.58)",
    fill: "#76FFD5"
  }))), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.394749,
    cy: 0.394749,
    r: 0.394749,
    transform: "matrix(0.742795 0.669519 -0.670589 0.741829 363.438 293.58)",
    fill: "url(#paint41_radial_2615_299)"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter37_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.394749,
    cy: 0.394749,
    r: 0.394749,
    transform: "matrix(0.742795 0.669519 -0.670589 0.741829 367.921 282.729)",
    fill: "#76FFD5"
  }))), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.394749,
    cy: 0.394749,
    r: 0.394749,
    transform: "matrix(0.742795 0.669519 -0.670589 0.741829 367.921 282.729)",
    fill: "url(#paint42_radial_2615_299)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M361.208 191.348C363.313 189.605 364.892 187.2 365.55 184.34C367.145 177.414 362.802 170.486 355.866 168.893C348.931 167.3 341.992 171.637 340.397 178.563C338.802 185.488 343.145 192.417 350.081 194.01C352.945 194.668 355.803 194.301 358.293 193.172L363.782 201.929L366.698 200.106L361.208 191.348ZM350.852 190.661C345.766 189.493 342.581 184.41 343.751 179.333C344.92 174.256 350.009 171.074 355.095 172.242C360.181 173.41 363.366 178.492 362.197 183.569C361.027 188.646 355.938 191.829 350.852 190.661Z",
    fill: "url(#paint43_linear_2615_299)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M348.189 186.207C348.271 186.226 348.344 186.18 348.379 186.099C348.999 184.429 349.301 184.224 351.049 184.426C351.139 184.437 351.214 184.385 351.233 184.303C351.252 184.222 351.206 184.145 351.121 184.112C349.46 183.532 349.278 183.216 349.452 181.443C349.456 181.355 349.409 181.285 349.327 181.266C349.245 181.247 349.173 181.29 349.14 181.372C348.521 183.042 348.215 183.246 346.471 183.044C346.377 183.036 346.303 183.085 346.284 183.167C346.265 183.248 346.31 183.328 346.399 183.358C348.045 183.971 348.228 184.255 348.068 186.027C348.061 186.115 348.107 186.189 348.189 186.207Z",
    fill: "url(#paint44_linear_2615_299)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M354.342 185.886C354.505 185.924 354.652 185.832 354.723 185.669C355.962 182.329 356.567 181.918 360.062 182.324C360.242 182.346 360.392 182.241 360.43 182.078C360.467 181.915 360.377 181.761 360.206 181.696C356.885 180.536 356.521 179.903 356.868 176.358C356.875 176.181 356.782 176.04 356.618 176.003C356.455 175.965 356.309 176.051 356.245 176.215C355.006 179.555 354.395 179.964 350.906 179.56C350.718 179.543 350.57 179.641 350.532 179.805C350.494 179.968 350.583 180.128 350.761 180.188C354.054 181.414 354.42 181.981 354.1 185.526C354.086 185.702 354.178 185.849 354.342 185.886Z",
    fill: "url(#paint45_linear_2615_299)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M146.834 93.933C146.937 96.2293 142.397 99.7738 129.032 100.566C116.016 101.338 110.822 98.0543 110.678 94.835C110.534 91.6157 115.186 90.5635 128.512 88.9082C147 89.8548 146.669 90.2236 146.834 93.933Z",
    fill: "url(#paint46_radial_2615_299)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M120.807 83.9416C119.253 86.5594 119.075 89.3284 119.18 90.3856L137.93 89.3738C137.772 85.841 136.28 83.6065 135.554 82.9309C133.545 81.6044 129.58 81.663 127.849 81.8581C123.529 81.7672 121.354 83.2092 120.807 83.9416Z",
    fill: "url(#paint47_radial_2615_299)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M120.088 102.912L119.093 100.124L138.892 99.2424L138.324 102.1C140.282 102.296 143.008 103.071 144.126 103.434L132.955 110.48L133.998 106.54L112.264 118.658L112.991 111.546C115.914 113.841 117.34 107.636 119.219 106.844L117.68 103.55L120.088 102.912Z",
    fill: "url(#paint48_radial_2615_299)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M126.724 95.3898L120.813 93.9835C120.537 94.5175 121.026 95.3931 122.852 95.9796C124.678 96.5661 126.194 95.8307 126.724 95.3898Z",
    fill: "#16161A",
    stroke: "#16161A",
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M130.87 95.2053L136.632 93.2792C136.955 93.7865 136.546 94.7021 134.78 95.4485C133.014 96.195 131.437 95.5974 130.87 95.2053Z",
    fill: "#16161A",
    stroke: "#16161A",
    strokeWidth: 0.5
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter38_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.389911,
    cy: 0.389911,
    r: 0.389911,
    transform: "matrix(0.909836 -0.414968 0.415965 0.909381 44.4619 147.329)",
    fill: "#76FFD5"
  }))), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.168861,
    cy: 0.168861,
    r: 0.168861,
    transform: "matrix(0.921421 -0.388567 0.389524 0.921016 358.185 91.0298)",
    fill: "url(#paint49_radial_2615_299)"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter39_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.259941,
    cy: 0.259941,
    r: 0.259941,
    transform: "matrix(0.909836 -0.414968 0.415965 0.909381 60.7307 175.369)",
    fill: "#76FFD5"
  }))), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.259941,
    cy: 0.259941,
    r: 0.259941,
    transform: "matrix(0.909836 -0.414968 0.415965 0.909381 60.7307 175.369)",
    fill: "url(#paint50_radial_2615_299)"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter40_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.12997,
    cy: 0.12997,
    r: 0.12997,
    transform: "matrix(0.909836 -0.414968 0.415965 0.909381 65.2354 176.458)",
    fill: "#76FFD5"
  }))), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.12997,
    cy: 0.12997,
    r: 0.12997,
    transform: "matrix(0.909836 -0.414968 0.415965 0.909381 65.2354 176.458)",
    fill: "url(#paint51_radial_2615_299)"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter41_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.12997,
    cy: 0.12997,
    r: 0.12997,
    transform: "matrix(0.909836 -0.414968 0.415965 0.909381 61.5665 184.704)",
    fill: "#76FFD5"
  }))), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.12997,
    cy: 0.12997,
    r: 0.12997,
    transform: "matrix(0.909836 -0.414968 0.415965 0.909381 61.5665 184.704)",
    fill: "url(#paint52_radial_2615_299)"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.12997,
    cy: 0.12997,
    r: 0.12997,
    transform: "matrix(0.909836 -0.414968 0.415965 0.909381 35.0781 160.417)",
    fill: "url(#paint53_radial_2615_299)"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter42_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.276456,
    cy: 0.276456,
    r: 0.276456,
    transform: "matrix(-0.8339 -0.551916 0.553029 -0.833162 57.4121 159.443)",
    fill: "#76FFD5"
  }))), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.276456,
    cy: 0.276456,
    r: 0.276456,
    transform: "matrix(-0.8339 -0.551916 0.553029 -0.833162 62.1306 164.245)",
    fill: "url(#paint54_radial_2615_299)"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter43_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.276456,
    cy: 0.276456,
    r: 0.276456,
    transform: "matrix(-0.8339 -0.551916 0.553029 -0.833162 55.437 167.422)",
    fill: "#76FFD5"
  }))), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.276456,
    cy: 0.276456,
    r: 0.276456,
    transform: "matrix(-0.8339 -0.551916 0.553029 -0.833162 55.437 167.422)",
    fill: "url(#paint55_radial_2615_299)"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.324802,
    cy: 0.324802,
    r: 0.324802,
    transform: "matrix(0.133268 -0.99108 0.991131 0.132889 44.6143 147.738)",
    fill: "url(#paint56_radial_2615_299)"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter44_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.216534,
    cy: 0.216534,
    r: 0.216534,
    transform: "matrix(0.133268 -0.99108 0.991131 0.132889 34.6055 170.088)",
    fill: "#76FFD5"
  }))), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.216534,
    cy: 0.216534,
    r: 0.216534,
    transform: "matrix(0.133268 -0.99108 0.991131 0.132889 34.6055 170.088)",
    fill: "url(#paint57_radial_2615_299)"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter45_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.216534,
    cy: 0.216534,
    r: 0.216534,
    transform: "matrix(0.133268 -0.99108 0.991131 0.132889 32.8772 179.688)",
    fill: "#76FFD5"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter46_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.108267,
    cy: 0.108267,
    r: 0.108267,
    transform: "matrix(0.133268 -0.99108 0.991131 0.132889 31.8503 174.306)",
    fill: "#76FFD5"
  }))), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.108267,
    cy: 0.108267,
    r: 0.108267,
    transform: "matrix(0.133268 -0.99108 0.991131 0.132889 30.0165 184.908)",
    fill: "url(#paint58_radial_2615_299)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M381.168 98.9785C381.155 98.6911 381.02 98.4231 380.797 98.241V98.241C379.804 97.421 378.924 96.4685 378.18 95.4091C377.353 93.9376 376.822 92.3131 376.618 90.6308L376.382 85.6585C376.263 83.0067 375.198 80.4885 373.388 78.5773C371.881 76.9856 369.943 75.9061 367.839 75.4659C367.111 75.3137 366.527 74.7235 366.491 73.9808V73.9808C366.474 73.6244 366.319 73.2892 366.06 73.0489C365.801 72.8086 365.46 72.6829 365.11 72.6994C364.761 72.7159 364.432 72.8734 364.197 73.1371C363.962 73.4007 363.84 73.7491 363.856 74.1055V74.1055C363.892 74.8617 363.361 75.5175 362.641 75.7506C360.62 76.4048 358.827 77.6621 357.502 79.3744C355.903 81.4403 355.197 84.1765 355.327 86.8076L355.555 91.6128C355.512 93.3069 355.042 94.9932 354.358 96.5362C353.729 97.6578 352.957 98.6884 352.06 99.6006V99.6006C351.856 99.8029 351.747 100.083 351.76 100.37L351.78 100.793C351.832 101.878 352.753 102.715 353.837 102.664L379.318 101.458C380.402 101.407 381.24 100.486 381.188 99.4017L381.168 98.9785Z",
    fill: "url(#paint59_radial_2615_299)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M365.694 103.214C365.81 103.768 366.115 104.261 366.552 104.601C366.988 104.941 367.528 105.107 368.07 105.066C368.612 105.025 369.121 104.781 369.501 104.379C369.882 103.978 370.11 103.445 370.142 102.88L365.694 103.214Z",
    fill: "#76FFD5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M355.267 85.6509C355.33 86.9731 362.692 93.911 370.699 97.1561L371.268 97.3798C371.078 97.3074 370.888 97.2327 370.699 97.1561L355.53 91.1878L355.267 85.6509Z",
    fill: "#08080C"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter47_d_2615_299)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.221,
    y: 40,
    width: 161.234,
    height: 161,
    rx: 9,
    fill: "url(#paint60_linear_2615_299)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.721,
    y: 40.5,
    width: 160.234,
    height: 160,
    rx: 8.5,
    stroke: "url(#paint61_linear_2615_299)"
  }))), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 0.562717,
    cy: 0.563077,
    rx: 0.562717,
    ry: 0.563077,
    transform: "matrix(-0.529205 0.848494 -0.849182 -0.528101 211.298 148.34)",
    fill: "url(#paint62_radial_2615_299)"
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter48_f_2615_299)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.562717,
    cy: 0.563077,
    rx: 0.562717,
    ry: 0.563077,
    transform: "matrix(-0.529205 0.848494 -0.849182 -0.528101 232.479 101.363)",
    fill: "#76FFD5"
  }))), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 0.562717,
    cy: 0.563077,
    rx: 0.562717,
    ry: 0.563077,
    transform: "matrix(-0.529205 0.848494 -0.849182 -0.528101 232.479 101.363)",
    fill: "url(#paint63_radial_2615_299)"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter49_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.281244,
    cy: 0.281244,
    r: 0.281244,
    transform: "matrix(-0.529205 0.848494 -0.849182 -0.528101 232.413 134.458)",
    fill: "#76FFD5"
  }))), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 0.281244,
    cy: 0.281244,
    r: 0.281244,
    transform: "matrix(-0.529205 0.848494 -0.849182 -0.528101 232.413 134.458)",
    fill: "url(#paint64_radial_2615_299)"
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter50_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.281244,
    cy: 0.281244,
    r: 0.281244,
    transform: "matrix(-0.529205 0.848494 -0.849182 -0.528101 229.157 115.201)",
    fill: "#76FFD5"
  }))), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 0.281244,
    cy: 0.281244,
    r: 0.281244,
    transform: "matrix(-0.529205 0.848494 -0.849182 -0.528101 229.157 115.201)",
    fill: "url(#paint65_radial_2615_299)"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 0.281244,
    cy: 0.281244,
    r: 0.281244,
    transform: "matrix(-0.529205 0.848494 -0.849182 -0.528101 312.264 141.489)",
    fill: "url(#paint66_radial_2615_299)"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 0.202734,
    cy: 0.202734,
    r: 0.202734,
    transform: "matrix(-0.961299 0.275507 -0.276246 -0.961087 190.751 134.259)",
    fill: "url(#paint67_radial_2615_299)"
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter51_f_2615_299)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.506698,
    cy: 0.507319,
    rx: 0.506698,
    ry: 0.507319,
    transform: "matrix(-0.279061 0.960273 -0.96049 -0.278316 204.577 112.392)",
    fill: "#76FFD5"
  }))), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 0.506698,
    cy: 0.507319,
    rx: 0.506698,
    ry: 0.507319,
    transform: "matrix(-0.279061 0.960273 -0.96049 -0.278316 204.577 112.392)",
    fill: "url(#paint68_radial_2615_299)"
  })), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter52_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.337761,
    cy: 0.337761,
    r: 0.337761,
    transform: "matrix(-0.279061 0.960273 -0.96049 -0.278316 208.863 120.667)",
    fill: "#76FFD5"
  }))), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 0.337761,
    cy: 0.337761,
    r: 0.337761,
    transform: "matrix(-0.279061 0.960273 -0.96049 -0.278316 208.863 120.667)",
    fill: "url(#paint69_radial_2615_299)"
  })), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter53_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.337761,
    cy: 0.337761,
    r: 0.337761,
    transform: "matrix(-0.279061 0.960273 -0.96049 -0.278316 193.722 119.445)",
    fill: "#76FFD5"
  }))), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 0.337761,
    cy: 0.337761,
    r: 0.337761,
    transform: "matrix(-0.279061 0.960273 -0.96049 -0.278316 193.722 119.445)",
    fill: "url(#paint70_radial_2615_299)"
  })), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter54_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.337761,
    cy: 0.337761,
    r: 0.337761,
    transform: "matrix(-0.279061 0.960273 -0.96049 -0.278316 198.613 105.037)",
    fill: "#76FFD5"
  }))), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 0.337761,
    cy: 0.337761,
    r: 0.337761,
    transform: "matrix(-0.279061 0.960273 -0.96049 -0.278316 198.613 105.037)",
    fill: "url(#paint71_radial_2615_299)"
  })), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter55_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.16888,
    cy: 0.16888,
    r: 0.16888,
    transform: "matrix(-0.279061 0.960273 -0.96049 -0.278316 203.97 124.173)",
    fill: "#76FFD5"
  }))), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 0.16888,
    cy: 0.16888,
    r: 0.16888,
    transform: "matrix(-0.279061 0.960273 -0.96049 -0.278316 203.97 124.173)",
    fill: "url(#paint72_radial_2615_299)"
  })), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter56_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.16888,
    cy: 0.16888,
    r: 0.16888,
    transform: "matrix(-0.279061 0.960273 -0.96049 -0.278316 198.95 113.575)",
    fill: "#76FFD5"
  }))), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 0.16888,
    cy: 0.16888,
    r: 0.16888,
    transform: "matrix(-0.279061 0.960273 -0.96049 -0.278316 198.95 113.575)",
    fill: "url(#paint73_radial_2615_299)"
  })), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter57_f_2615_299)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.703037,
    cy: 0.703668,
    rx: 0.703037,
    ry: 0.703668,
    transform: "matrix(0.437146 0.89939 -0.899888 0.436121 268.994 102.953)",
    fill: "#76FFD5"
  }))), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 0.703037,
    cy: 0.703668,
    rx: 0.703037,
    ry: 0.703668,
    transform: "matrix(0.437146 0.89939 -0.899888 0.436121 268.994 102.953)",
    fill: "url(#paint74_radial_2615_299)"
  })), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter58_f_2615_299)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.468691,
    cy: 0.469112,
    rx: 0.468691,
    ry: 0.469112,
    transform: "matrix(0.437146 0.89939 -0.899888 0.436121 312.015 96.5825)",
    fill: "#76FFD5"
  }))), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 0.468691,
    cy: 0.469112,
    rx: 0.468691,
    ry: 0.469112,
    transform: "matrix(0.437146 0.89939 -0.899888 0.436121 312.015 96.5825)",
    fill: "url(#paint75_radial_2615_299)"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 0.468691,
    cy: 0.469112,
    rx: 0.468691,
    ry: 0.469112,
    transform: "matrix(0.437146 0.89939 -0.899888 0.436121 283.888 108.415)",
    fill: "url(#paint76_radial_2615_299)"
  })), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter59_f_2615_299)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.468691,
    cy: 0.469112,
    rx: 0.468691,
    ry: 0.469112,
    transform: "matrix(0.437146 0.89939 -0.899888 0.436121 286.909 90)",
    fill: "#76FFD5"
  }))), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 0.468691,
    cy: 0.469112,
    rx: 0.468691,
    ry: 0.469112,
    transform: "matrix(0.437146 0.89939 -0.899888 0.436121 286.909 90)",
    fill: "url(#paint77_radial_2615_299)"
  })), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter60_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.234281,
    cy: 0.234281,
    r: 0.234281,
    transform: "matrix(0.437146 0.89939 -0.899888 0.436121 310.24 104.734)",
    fill: "#76FFD5"
  }))), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 0.234281,
    cy: 0.234281,
    r: 0.234281,
    transform: "matrix(0.437146 0.89939 -0.899888 0.436121 310.24 104.734)",
    fill: "url(#paint78_radial_2615_299)"
  })), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter61_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.234281,
    cy: 0.234281,
    r: 0.234281,
    transform: "matrix(0.437146 0.89939 -0.899888 0.436121 295.204 98.48)",
    fill: "#76FFD5"
  }))), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 0.234281,
    cy: 0.234281,
    r: 0.234281,
    transform: "matrix(0.437146 0.89939 -0.899888 0.436121 295.204 98.48)",
    fill: "url(#paint79_radial_2615_299)"
  })), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter62_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.0639442,
    cy: 0.0639442,
    r: 0.0639442,
    transform: "matrix(0.437146 0.89939 -0.899888 0.436121 250.769 115.252)",
    fill: "#76FFD5"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter63_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.283963,
    cy: 0.283963,
    r: 0.283963,
    transform: "matrix(0.433731 0.901042 -0.901533 0.432711 293.493 153.353)",
    fill: "#76FFD5"
  }))), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 0.283963,
    cy: 0.283963,
    r: 0.283963,
    transform: "matrix(0.433731 0.901042 -0.901533 0.432711 293.493 153.353)",
    fill: "url(#paint80_radial_2615_299)"
  })), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter64_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.141981,
    cy: 0.141981,
    r: 0.141981,
    transform: "matrix(0.433731 0.901042 -0.901533 0.432711 292.398 158.29)",
    fill: "#76FFD5"
  }))), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 0.141981,
    cy: 0.141981,
    r: 0.141981,
    transform: "matrix(0.433731 0.901042 -0.901533 0.432711 292.398 158.29)",
    fill: "url(#paint81_radial_2615_299)"
  })), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter65_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.141981,
    cy: 0.141981,
    r: 0.141981,
    transform: "matrix(0.433731 0.901042 -0.901533 0.432711 283.3 154.464)",
    fill: "#76FFD5"
  }))), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 0.141981,
    cy: 0.141981,
    r: 0.141981,
    transform: "matrix(0.433731 0.901042 -0.901533 0.432711 283.3 154.464)",
    fill: "url(#paint82_radial_2615_299)"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 0.302004,
    cy: 0.302004,
    r: 0.302004,
    transform: "matrix(0.536578 -0.843851 0.844554 0.53547 305.691 154.642)",
    fill: "url(#paint83_radial_2615_299)"
  })), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter66_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.302004,
    cy: 0.302004,
    r: 0.302004,
    transform: "matrix(0.536578 -0.843851 0.844554 0.53547 302.072 147.41)",
    fill: "#76FFD5"
  }))), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 0.302004,
    cy: 0.302004,
    r: 0.302004,
    transform: "matrix(0.536578 -0.843851 0.844554 0.53547 302.072 147.41)",
    fill: "url(#paint84_radial_2615_299)"
  })), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter67_f_2615_299)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.515114,
    cy: 0.515443,
    rx: 0.515114,
    ry: 0.515443,
    transform: "matrix(-0.529205 0.848494 -0.849182 -0.528101 210.935 120.668)",
    fill: "#76FFD5"
  }))), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.515114,
    cy: 0.515443,
    rx: 0.515114,
    ry: 0.515443,
    transform: "matrix(-0.529205 0.848494 -0.849182 -0.528101 210.935 120.668)",
    fill: "url(#paint85_radial_2615_299)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-152-inside-3_2615_299",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.221 49C171.221 44.0294 175.25 40 180.221 40H323.454C328.425 40 332.454 44.0294 332.454 49V108H171.221V49Z"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M171.221 49C171.221 44.0294 175.25 40 180.221 40H323.454C328.425 40 332.454 44.0294 332.454 49V108H171.221V49Z",
    fill: "url(#paint86_linear_2615_299)",
    fillOpacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M171.221 49C171.221 43.4772 175.698 39 181.221 39H322.454C327.977 39 332.454 43.4772 332.454 49C332.454 44.5817 328.425 41 323.454 41H180.221C175.25 41 171.221 44.5817 171.221 49ZM332.454 108H171.221H332.454ZM171.221 108V40V108ZM332.454 40V108V40Z",
    fill: "url(#paint87_linear_2615_299)",
    mask: "url(#path-152-inside-3_2615_299)"
  })), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter68_f_2615_299)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.82,
    cy: 122.5,
    rx: 0.500725,
    ry: 0.5,
    fill: "#76FFD5"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M294.619 133.48V131.48V129.48H310.405V133.48H294.619Z",
    fill: "#76FFD5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M278.104 125.722V123.904V122.085H289.519V133.481H285.876V131.238C285.876 130.001 285.839 128.995 285.791 128.995C285.73 128.995 284.479 130.001 280.29 133.481H277.011C275.202 133.481 273.708 133.444 273.672 133.384C273.648 133.335 275.639 131.65 278.104 129.638C280.581 127.613 282.597 125.916 282.597 125.843C282.597 125.771 281.771 125.722 278.104 125.722Z",
    fill: "#76FFD5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M294.619 124.025V122.025V120.024H310.405V124.025H294.619Z",
    fill: "#76FFD5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M294.619 114.691V112.691V110.69H310.405V114.691H294.619Z",
    fill: "#76FFD5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M276.404 110.569C276.902 110.424 277.837 110.23 278.469 110.145C279.1 110.06 279.671 109.987 279.719 109.975C279.768 109.975 280.339 110.036 280.994 110.133C281.638 110.23 282.439 110.375 282.779 110.46C283.107 110.545 283.799 110.775 284.297 110.993C284.795 111.199 285.536 111.587 285.937 111.854C286.337 112.133 286.957 112.642 287.321 113.006C287.685 113.369 288.183 113.963 288.438 114.327C288.681 114.691 288.997 115.236 289.13 115.539C289.264 115.842 289.458 116.376 289.762 117.358H284.601L284.237 116.739C284.042 116.4 283.654 115.927 283.387 115.685C283.119 115.442 282.597 115.115 282.233 114.957C281.869 114.788 281.189 114.594 280.715 114.533C280.132 114.448 279.598 114.436 279.015 114.521C278.529 114.594 277.801 114.824 277.315 115.042C276.756 115.309 276.246 115.673 275.833 116.097C275.445 116.485 275.02 117.115 274.765 117.624C274.534 118.109 274.255 118.837 274.158 119.237C274.061 119.637 273.927 120.437 273.793 122.085H271.28C269.337 122.085 268.754 122.049 268.754 121.94C268.754 121.855 268.815 121.213 268.875 120.51C268.948 119.806 269.118 118.825 269.24 118.328C269.373 117.83 269.628 117.03 269.823 116.57C270.017 116.109 270.381 115.394 270.624 114.994C270.879 114.594 271.316 114 271.608 113.66C271.887 113.333 272.494 112.751 272.956 112.387C273.417 112.024 274.17 111.527 274.643 111.284C275.105 111.042 275.906 110.727 276.404 110.569Z",
    fill: "#76FFD5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M226.01 133.844V122.146V110.448H241.796V114.448H230.989V120.025H240.946V124.146H230.989V129.723H241.796V133.844H226.01Z",
    fill: "#76FFD5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M245.743 114.63L245.718 112.533L245.694 110.436L251.183 110.484C256.368 110.533 256.732 110.545 257.643 110.799C258.177 110.945 259.161 111.333 259.829 111.66C260.497 111.987 261.347 112.496 261.711 112.799C262.075 113.102 262.622 113.648 262.925 114.012C263.229 114.375 263.654 114.969 263.86 115.321C264.079 115.672 264.407 116.315 264.577 116.751C264.759 117.188 265.002 117.952 265.135 118.449C265.33 119.14 265.402 119.891 265.439 121.54C265.487 123.213 265.451 123.989 265.305 124.837C265.196 125.455 264.953 126.413 264.747 126.959C264.552 127.516 264.188 128.292 263.945 128.692C263.715 129.092 263.29 129.71 263.01 130.074C262.731 130.426 262.172 130.983 261.772 131.311C261.371 131.638 260.606 132.135 260.072 132.414C259.537 132.692 258.797 133.02 258.432 133.141C258.068 133.262 257.194 133.468 256.489 133.602C255.336 133.82 254.765 133.844 245.743 133.784V129.613L250.539 129.565C254.534 129.516 255.457 129.48 256.064 129.31C256.465 129.201 257.084 128.971 257.424 128.813C257.777 128.644 258.359 128.219 258.712 127.868C259.1 127.492 259.513 126.922 259.744 126.449C259.95 126.013 260.217 125.249 260.327 124.752C260.46 124.134 260.533 123.285 260.533 122.085C260.533 120.97 260.46 120.024 260.351 119.479C260.254 119.018 259.999 118.279 259.792 117.842C259.586 117.406 259.234 116.836 259.003 116.57C258.784 116.303 258.299 115.891 257.934 115.66C257.57 115.43 256.951 115.139 256.55 115.006C255.882 114.775 255.396 114.751 245.743 114.63Z",
    fill: "#76FFD5"
  })), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter69_f_2615_299)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.177958,
    cy: 0.177958,
    r: 0.177958,
    transform: "matrix(-0.529205 0.848494 -0.849182 -0.528101 213.936 121.271)",
    fill: "#76FFD5"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M211.279 109H204.627L196.257 123.657L202.684 135H209.261L202.983 123.657L211.279 109Z",
    fill: "#76FFD5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M217.756 117H212.039L208.274 123.554L213.155 132H219.29L214.131 123.554L217.756 117Z",
    fill: "#76FFD5"
  })), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter70_d_2615_299)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97.0478,
    height: 26.7491,
    rx: 13.3746,
    transform: "matrix(0.999937 0.0111842 -0.0112167 0.999937 60.3925 149.724)",
    fill: "url(#paint88_linear_2615_299)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.49436,
    y: 0.505561,
    width: 96.0478,
    height: 25.7491,
    rx: 12.8746,
    transform: "matrix(0.999937 0.0111842 -0.0112167 0.999937 60.3982 149.719)",
    stroke: "url(#paint89_linear_2615_299)",
    strokeOpacity: 0.3
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0546 169.134C72.5375 169.134 72.042 169.051 71.568 168.884C71.0941 168.715 70.6725 168.447 70.3031 168.081C69.9338 167.712 69.643 167.229 69.4306 166.632C69.2183 166.031 69.1136 165.3 69.1167 164.439C69.1198 163.66 69.2152 162.961 69.4029 162.343C69.5907 161.721 69.8584 161.193 70.2062 160.759C70.557 160.325 70.9756 159.995 71.4619 159.767C71.9512 159.536 72.4975 159.421 73.1007 159.421C73.7624 159.421 74.3456 159.55 74.8504 159.808C75.3582 160.064 75.7644 160.409 76.0691 160.842C76.3738 161.273 76.5538 161.753 76.6092 162.283H74.361C74.2933 161.984 74.144 161.758 73.9132 161.604C73.6855 161.447 73.4146 161.369 73.1007 161.369C72.5221 161.369 72.0897 161.62 71.8035 162.121C71.5203 162.623 71.3757 163.294 71.3695 164.134H71.4296C71.5588 163.851 71.745 163.608 71.9881 163.405C72.2313 163.201 72.5098 163.046 72.8237 162.938C73.1407 162.828 73.4762 162.772 73.8301 162.772C74.3964 162.772 74.8965 162.903 75.3305 163.165C75.7644 163.426 76.1045 163.785 76.3507 164.24C76.5969 164.693 76.7185 165.211 76.7154 165.796C76.7185 166.455 76.5646 167.036 76.2538 167.541C75.9429 168.043 75.5121 168.433 74.9612 168.714C74.4133 168.994 73.7778 169.134 73.0546 169.134ZM73.0407 167.379C73.3208 167.379 73.5716 167.313 73.7932 167.181C74.0148 167.049 74.1887 166.869 74.3149 166.641C74.441 166.413 74.5026 166.156 74.4995 165.87C74.5026 165.581 74.441 165.324 74.3149 165.099C74.1917 164.874 74.0194 164.696 73.7978 164.563C73.5793 164.431 73.3285 164.365 73.0453 164.365C72.8391 164.365 72.6468 164.403 72.4683 164.48C72.2898 164.557 72.1343 164.665 72.002 164.803C71.8727 164.939 71.7712 165.099 71.6973 165.284C71.6234 165.465 71.585 165.662 71.5819 165.874C71.585 166.154 71.6496 166.408 71.7758 166.636C71.902 166.864 72.0743 167.045 72.2928 167.181C72.5113 167.313 72.7606 167.379 73.0407 167.379ZM80.8229 169.004V159.55H87.2768V161.406H83.1081V163.345H86.8659V165.205H83.1081V169.004H80.8229ZM92.558 165.944V161.913H94.8109V169.004H92.6596V167.684H92.5857C92.4288 168.118 92.161 168.463 91.7824 168.718C91.407 168.971 90.953 169.097 90.4206 169.097C89.9374 169.097 89.5127 168.986 89.1464 168.764C88.7802 168.543 88.4955 168.233 88.2924 167.836C88.0893 167.436 87.9862 166.969 87.9831 166.433V161.913H90.2405V165.99C90.2436 166.375 90.3452 166.678 90.5452 166.899C90.7453 167.121 91.0177 167.232 91.3623 167.232C91.587 167.232 91.7886 167.182 91.9671 167.084C92.1487 166.982 92.2918 166.836 92.3964 166.645C92.5042 166.451 92.558 166.218 92.558 165.944ZM98.5052 164.96V169.004H96.2477V161.913H98.3944V163.215H98.4729C98.6298 162.781 98.8976 162.441 99.2761 162.195C99.6547 161.946 100.106 161.821 100.629 161.821C101.127 161.821 101.56 161.933 101.926 162.158C102.295 162.38 102.582 162.691 102.785 163.091C102.991 163.488 103.092 163.952 103.089 164.485V169.004H100.832V164.928C100.835 164.534 100.735 164.226 100.532 164.005C100.332 163.783 100.053 163.672 99.6962 163.672C99.4593 163.672 99.25 163.725 99.0684 163.829C98.8899 163.931 98.7514 164.077 98.6529 164.268C98.5575 164.459 98.5083 164.69 98.5052 164.96ZM106.523 167.144L106.532 164.453H106.846L108.84 161.913H111.398L108.434 165.551H107.839L106.523 167.144ZM104.487 169.004V159.55H106.744V169.004H104.487ZM108.891 169.004L107.035 166.059L108.522 164.457L111.499 169.004H108.891ZM116.208 161.913V163.575H111.735V161.913H116.208ZM112.672 160.215H114.929V166.775C114.929 166.913 114.951 167.025 114.994 167.112C115.04 167.195 115.106 167.255 115.193 167.292C115.279 167.326 115.382 167.342 115.502 167.342C115.588 167.342 115.679 167.335 115.774 167.319C115.873 167.301 115.947 167.286 115.996 167.273L116.337 168.903C116.23 168.934 116.077 168.972 115.88 169.018C115.687 169.064 115.454 169.094 115.183 169.106C114.654 169.131 114.2 169.069 113.822 168.921C113.446 168.77 113.158 168.537 112.958 168.22C112.761 167.903 112.666 167.504 112.672 167.024V160.215ZM117.36 169.004V161.913H119.617V169.004H117.36ZM118.491 161.087C118.174 161.087 117.902 160.982 117.674 160.773C117.446 160.561 117.332 160.305 117.332 160.007C117.332 159.711 117.446 159.459 117.674 159.25C117.902 159.037 118.174 158.931 118.491 158.931C118.811 158.931 119.084 159.037 119.308 159.25C119.536 159.459 119.65 159.711 119.65 160.007C119.65 160.305 119.536 160.561 119.308 160.773C119.084 160.982 118.811 161.087 118.491 161.087ZM124.364 169.138C123.62 169.138 122.979 168.986 122.444 168.681C121.912 168.373 121.501 167.946 121.211 167.398C120.925 166.847 120.782 166.208 120.782 165.482C120.782 164.753 120.925 164.114 121.211 163.566C121.501 163.015 121.912 162.587 122.444 162.283C122.979 161.975 123.62 161.821 124.364 161.821C125.109 161.821 125.748 161.975 126.28 162.283C126.816 162.587 127.227 163.015 127.513 163.566C127.802 164.114 127.947 164.753 127.947 165.482C127.947 166.208 127.802 166.847 127.513 167.398C127.227 167.946 126.816 168.373 126.28 168.681C125.748 168.986 125.109 169.138 124.364 169.138ZM124.378 167.435C124.649 167.435 124.878 167.352 125.066 167.186C125.254 167.019 125.397 166.788 125.495 166.493C125.597 166.198 125.648 165.856 125.648 165.468C125.648 165.074 125.597 164.73 125.495 164.434C125.397 164.139 125.254 163.908 125.066 163.742C124.878 163.575 124.649 163.492 124.378 163.492C124.098 163.492 123.861 163.575 123.667 163.742C123.476 163.908 123.33 164.139 123.229 164.434C123.13 164.73 123.081 165.074 123.081 165.468C123.081 165.856 123.13 166.198 123.229 166.493C123.33 166.788 123.476 167.019 123.667 167.186C123.861 167.352 124.098 167.435 124.378 167.435ZM131.361 164.96V169.004H129.103V161.913H131.25V163.215H131.328C131.485 162.781 131.753 162.441 132.132 162.195C132.51 161.946 132.961 161.821 133.484 161.821C133.983 161.821 134.415 161.933 134.781 162.158C135.151 162.38 135.437 162.691 135.64 163.091C135.846 163.488 135.948 163.952 135.945 164.485V169.004H133.687V164.928C133.69 164.534 133.59 164.226 133.387 164.005C133.187 163.783 132.909 163.672 132.552 163.672C132.315 163.672 132.105 163.725 131.924 163.829C131.745 163.931 131.607 164.077 131.508 164.268C131.413 164.459 131.364 164.69 131.361 164.96ZM140.657 169.138C139.915 169.138 139.275 168.992 138.737 168.7C138.201 168.404 137.789 167.984 137.499 167.439C137.213 166.892 137.07 166.241 137.07 165.487C137.07 164.754 137.215 164.114 137.504 163.566C137.793 163.015 138.201 162.587 138.727 162.283C139.254 161.975 139.874 161.821 140.588 161.821C141.093 161.821 141.554 161.9 141.973 162.057C142.391 162.214 142.753 162.446 143.058 162.754C143.362 163.061 143.599 163.442 143.769 163.894C143.938 164.343 144.023 164.859 144.023 165.44V166.004H137.86V164.693H141.922C141.919 164.453 141.862 164.239 141.751 164.051C141.64 163.863 141.488 163.717 141.294 163.612C141.103 163.505 140.883 163.451 140.634 163.451C140.382 163.451 140.155 163.508 139.955 163.622C139.755 163.732 139.597 163.885 139.48 164.079C139.363 164.269 139.301 164.486 139.295 164.73V166.064C139.295 166.353 139.352 166.607 139.466 166.825C139.58 167.041 139.741 167.209 139.951 167.329C140.16 167.449 140.409 167.509 140.699 167.509C140.899 167.509 141.08 167.481 141.243 167.426C141.407 167.37 141.547 167.289 141.663 167.181C141.78 167.073 141.868 166.941 141.927 166.784L143.999 166.844C143.913 167.309 143.724 167.713 143.432 168.058C143.142 168.4 142.762 168.666 142.291 168.857C141.82 169.044 141.276 169.138 140.657 169.138ZM147.433 164.96V169.004H145.175V161.913H147.322V163.215H147.401C147.558 162.781 147.825 162.441 148.204 162.195C148.582 161.946 149.033 161.821 149.557 161.821C150.055 161.821 150.487 161.933 150.854 162.158C151.223 162.38 151.509 162.691 151.712 163.091C151.919 163.488 152.02 163.952 152.017 164.485V169.004H149.76V164.928C149.763 164.534 149.663 164.226 149.46 164.005C149.26 163.783 148.981 163.672 148.624 163.672C148.387 163.672 148.178 163.725 147.996 163.829C147.818 163.931 147.679 164.077 147.581 164.268C147.485 164.459 147.436 164.69 147.433 164.96Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2615_299",
    x: 48.5754,
    y: 34.9707,
    width: 11.5077,
    height: 11.5054,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2615_299",
    x: 19.9001,
    y: 2.05176,
    width: 10.7538,
    height: 10.7529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2615_299",
    x: 39.9706,
    y: 18.8145,
    width: 10.7538,
    height: 10.7529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2615_299",
    x: 32.1461,
    y: 99.5664,
    width: 12.2618,
    height: 12.2588,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2615_299",
    x: 47.6586,
    y: 87.7642,
    width: 11.5079,
    height: 11.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_2615_299",
    x: 44.5835,
    y: 125.539,
    width: 11.5079,
    height: 11.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_2615_299",
    x: 14.2419,
    y: 110.325,
    width: 11.5079,
    height: 11.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_2615_299",
    x: 54.0891,
    y: 99.5054,
    width: 10.7531,
    height: 10.7524,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_2615_299",
    x: 33.4038,
    y: 112.089,
    width: 10.7532,
    height: 10.7524,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_2615_299",
    x: 59.6732,
    y: 173.479,
    width: 11.5079,
    height: 11.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_2615_299",
    x: 447.153,
    y: 32.9707,
    width: 11.5077,
    height: 11.5054,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_2615_299",
    x: 418.478,
    y: 0.0517578,
    width: 10.7538,
    height: 10.7529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_2615_299",
    x: 438.548,
    y: 16.8145,
    width: 10.7538,
    height: 10.7529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_2615_299",
    x: 430.724,
    y: 97.5664,
    width: 12.2618,
    height: 12.2588,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_2615_299",
    x: 446.236,
    y: 85.7642,
    width: 11.5079,
    height: 11.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_2615_299",
    x: 443.161,
    y: 123.539,
    width: 11.5079,
    height: 11.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_2615_299",
    x: 412.82,
    y: 108.325,
    width: 11.5079,
    height: 11.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_2615_299",
    x: 452.667,
    y: 97.5054,
    width: 10.7531,
    height: 10.7524,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_f_2615_299",
    x: 431.981,
    y: 110.089,
    width: 10.7531,
    height: 10.7524,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_2615_299",
    x: 458.25,
    y: 171.479,
    width: 11.5079,
    height: 11.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_d_2615_299",
    x: 109.824,
    y: 102.685,
    width: 281.348,
    height: 118.068,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2615_299"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2615_299",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_d_2615_299",
    x: 77.8228,
    y: 47.2993,
    width: 328.69,
    height: 94.2183,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2615_299"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2615_299",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_f_2615_299",
    x: 143.767,
    y: 254.624,
    width: 11.1154,
    height: 11.1138,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_f_2615_299",
    x: 138.987,
    y: 263.763,
    width: 10.7427,
    height: 10.7422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_f_2615_299",
    x: 131.259,
    y: 248.986,
    width: 10.7427,
    height: 10.7422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_f_2615_299",
    x: 147.542,
    y: 245.092,
    width: 10.7427,
    height: 10.7422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_f_2615_299",
    x: 133.272,
    y: 261.584,
    width: 10.3713,
    height: 10.3716,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_f_2615_299",
    x: 140.203,
    y: 250.716,
    width: 10.3713,
    height: 10.3716,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_f_2615_299",
    x: 140.757,
    y: 287.742,
    width: 10.79,
    height: 10.7891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_f_2615_299",
    x: 145.239,
    y: 276.892,
    width: 10.79,
    height: 10.7891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_f_2615_299",
    x: 361.082,
    y: 255.624,
    width: 11.1154,
    height: 11.1138,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_f_2615_299",
    x: 356.301,
    y: 264.763,
    width: 10.7427,
    height: 10.7422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_f_2615_299",
    x: 348.574,
    y: 249.986,
    width: 10.7427,
    height: 10.7422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter33_f_2615_299",
    x: 364.857,
    y: 246.092,
    width: 10.7427,
    height: 10.7422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter34_f_2615_299",
    x: 350.587,
    y: 262.584,
    width: 10.3713,
    height: 10.3716,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter35_f_2615_299",
    x: 357.517,
    y: 251.716,
    width: 10.3713,
    height: 10.3716,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter36_f_2615_299",
    x: 358.072,
    y: 288.742,
    width: 10.79,
    height: 10.7891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter37_f_2615_299",
    x: 362.554,
    y: 277.892,
    width: 10.79,
    height: 10.7891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter38_f_2615_299",
    x: 39.5887,
    y: 142.131,
    width: 10.7803,
    height: 10.7798,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter39_f_2615_299",
    x: 55.8152,
    y: 170.237,
    width: 10.5202,
    height: 10.5195,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter40_f_2615_299",
    x: 60.2776,
    y: 171.392,
    width: 10.2601,
    height: 10.2603,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter41_f_2615_299",
    x: 56.6087,
    y: 179.638,
    width: 10.2601,
    height: 10.2603,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter42_f_2615_299",
    x: 52.0578,
    y: 153.784,
    width: 10.5533,
    height: 10.5527,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter43_f_2615_299",
    x: 50.0827,
    y: 161.763,
    width: 10.5533,
    height: 10.5527,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter44_f_2615_299",
    x: 29.6323,
    y: 164.686,
    width: 10.4332,
    height: 10.4331,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter45_f_2615_299",
    x: 27.9041,
    y: 174.286,
    width: 10.4332,
    height: 10.4331,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter46_f_2615_299",
    x: 26.8638,
    y: 169.105,
    width: 10.2166,
    height: 10.2163,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter47_d_2615_299",
    x: 167.221,
    y: 36,
    width: 169.234,
    height: 169,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2615_299"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2615_299",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter48_f_2615_299",
    x: 226.14,
    y: 95.9805,
    width: 11.1268,
    height: 11.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter49_f_2615_299",
    x: 226.744,
    y: 129.268,
    width: 10.5629,
    height: 10.562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter50_f_2615_299",
    x: 223.488,
    y: 110.01,
    width: 10.5629,
    height: 10.562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter51_f_2615_299",
    x: 198.44,
    y: 107.23,
    width: 11.015,
    height: 11.0137,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter52_f_2615_299",
    x: 203.107,
    y: 115.56,
    width: 10.6758,
    height: 10.6758,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter53_f_2615_299",
    x: 187.965,
    y: 114.338,
    width: 10.6758,
    height: 10.6758,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter54_f_2615_299",
    x: 192.857,
    y: 99.9292,
    width: 10.6758,
    height: 10.6758,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter55_f_2615_299",
    x: 198.592,
    y: 119.12,
    width: 10.3379,
    height: 10.3379,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter56_f_2615_299",
    x: 193.571,
    y: 108.521,
    width: 10.3379,
    height: 10.3379,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter57_f_2615_299",
    x: 262.964,
    y: 98.1895,
    width: 11.408,
    height: 11.4058,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter58_f_2615_299",
    x: 306.329,
    y: 91.7397,
    width: 10.9387,
    height: 10.9375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter59_f_2615_299",
    x: 281.223,
    y: 85.1572,
    width: 10.9387,
    height: 10.9375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter60_f_2615_299",
    x: 304.898,
    y: 99.813,
    width: 10.4689,
    height: 10.4683,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter61_f_2615_299",
    x: 289.861,
    y: 93.5586,
    width: 10.4689,
    height: 10.4683,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter62_f_2615_299",
    x: 245.676,
    y: 110.274,
    width: 10.128,
    height: 10.1279,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter63_f_2615_299",
    x: 288.076,
    y: 148.448,
    width: 10.5683,
    height: 10.5679,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter64_f_2615_299",
    x: 287.19,
    y: 153.337,
    width: 10.2842,
    height: 10.2842,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter65_f_2615_299",
    x: 278.092,
    y: 149.512,
    width: 10.2842,
    height: 10.2842,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter66_f_2615_299",
    x: 297.186,
    y: 142.015,
    width: 10.6044,
    height: 10.6035,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter67_f_2615_299",
    x: 204.709,
    y: 115.318,
    width: 11.0314,
    height: 11.0298,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter68_f_2615_299",
    x: 234.319,
    y: 117,
    width: 11.0015,
    height: 11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter69_f_2615_299",
    x: 208.513,
    y: 116.15,
    width: 10.3562,
    height: 10.356,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2615_299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter70_d_2615_299",
    x: 56.2416,
    y: 145.873,
    width: 105.043,
    height: 35.5352,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2615_299"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2615_299",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.75268 0.753723) rotate(90) scale(1.00496 1.00357)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.37634 0.376862) rotate(90) scale(0.502482 0.501787)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.37634 0.376862) rotate(90) scale(0.502482 0.501787)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.13035 1.12926) rotate(90) scale(1.50568 1.50713)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.753566 0.752838) rotate(90) scale(1.00378 1.00475)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.753566 0.752838) rotate(90) scale(1.00378 1.00475)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.753566 0.752838) rotate(90) scale(1.00378 1.00475)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.376328 0.376328) rotate(90) scale(0.50177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.376328 0.376328) rotate(90) scale(0.50177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.753566 0.752838) rotate(90) scale(1.00378 1.00475)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.75268 0.753723) rotate(90) scale(1.00496 1.00357)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.37634 0.376862) rotate(90) scale(0.502482 0.501787)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.37634 0.376862) rotate(90) scale(0.502482 0.501787)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.13035 1.12926) rotate(90) scale(1.50568 1.50713)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.753566 0.752838) rotate(90) scale(1.00378 1.00475)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.753566 0.752838) rotate(90) scale(1.00378 1.00475)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.753566 0.752838) rotate(90) scale(1.00378 1.00475)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.376328 0.376328) rotate(90) scale(0.50177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.376328 0.376328) rotate(90) scale(0.50177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.753566 0.752838) rotate(90) scale(1.00378 1.00475)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2615_299",
    x1: -131.313,
    y1: -2.17126,
    x2: -86.9863,
    y2: 119.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06060A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09090D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2615_299",
    x1: 19.182,
    y1: 46.4261,
    x2: 223.066,
    y2: 44.9352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76FFD5",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#479980",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2615_299",
    x1: 247.03,
    y1: 130.445,
    x2: 240.949,
    y2: 158.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EF2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2615_299",
    x1: 102.577,
    y1: 114.296,
    x2: 385.349,
    y2: 175.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19DCA1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#43FFC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D7656",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2615_299",
    x1: -154.616,
    y1: -2.67412,
    x2: -98.1398,
    y2: 144.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06060A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09090D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2615_299",
    x1: 240.496,
    y1: 58.7292,
    x2: 242.26,
    y2: 94.4041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EF2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2615_299",
    x1: 82.2511,
    y1: 84.432,
    x2: 400.453,
    y2: 69.5111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19DCA1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#43FFC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D7656",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.557496 0.556811) rotate(90) scale(0.742415 0.743328)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.371167 0.371167) rotate(90) scale(0.494889)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.371167 0.371167) rotate(90) scale(0.494889)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.371167 0.371167) rotate(90) scale(0.494889)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.185583 0.185583) rotate(90) scale(0.247444)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.185583 0.185583) rotate(90) scale(0.247444)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.394749 0.394749) rotate(90) scale(0.526331)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.394749 0.394749) rotate(90) scale(0.526331)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.557496 0.556811) rotate(90) scale(0.742415 0.743328)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.371167 0.371167) rotate(90) scale(0.494889)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.371167 0.371167) rotate(90) scale(0.494889)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.371167 0.371167) rotate(90) scale(0.494889)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.185583 0.185583) rotate(90) scale(0.247444)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.185583 0.185583) rotate(90) scale(0.247444)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.394749 0.394749) rotate(90) scale(0.526331)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.394749 0.394749) rotate(90) scale(0.526331)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2615_299",
    x1: 358.136,
    y1: 169.414,
    x2: 351.325,
    y2: 199.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BF7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DA77E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2615_299",
    x1: 358.136,
    y1: 169.414,
    x2: 351.325,
    y2: 199.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BF7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DA77E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2615_299",
    x1: 358.136,
    y1: 169.414,
    x2: 351.325,
    y2: 199.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BF7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DA77E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(127.993 97.219) rotate(84.9854) scale(20.7374 20.767)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66FFD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EC48D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(127.993 97.219) rotate(84.9854) scale(20.7374 20.767)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66FFD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EC48D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(127.993 97.219) rotate(84.9854) scale(20.7374 20.767)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66FFD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EC48D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.168861 0.168861) rotate(90) scale(0.225148)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.259941 0.259941) rotate(90) scale(0.346587)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.12997 0.12997) rotate(90) scale(0.173294)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.12997 0.12997) rotate(90) scale(0.173294)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.12997 0.12997) rotate(90) scale(0.173294)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.276456 0.276456) rotate(90) scale(0.368608)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.276456 0.276456) rotate(90) scale(0.368608)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.324802 0.324802) rotate(90) scale(0.433069)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.216534 0.216534) rotate(90) scale(0.288712)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.108267 0.108267) rotate(90) scale(0.144356)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(365.97 89.2472) rotate(96.157) scale(17.0408 41.4218)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76FFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EC48D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2615_299",
    x1: 92.9632,
    y1: 33.9733,
    x2: 259.5,
    y2: 131.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06060A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09090D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2615_299",
    x1: 301.398,
    y1: 201,
    x2: 202.485,
    y2: 39.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76FFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.562717 0.563077) rotate(90) scale(0.750769 0.75029)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.562717 0.563077) rotate(90) scale(0.750769 0.75029)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.281244 0.281244) rotate(90) scale(0.374993)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.281244 0.281244) rotate(90) scale(0.374993)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.281244 0.281244) rotate(90) scale(0.374993)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.202734 0.202734) rotate(90) scale(0.270312)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.506698 0.507319) rotate(90) scale(0.676425 0.675597)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.337761 0.337761) rotate(90) scale(0.450347)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.337761 0.337761) rotate(90) scale(0.450347)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.337761 0.337761) rotate(90) scale(0.450347)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.16888 0.16888) rotate(90) scale(0.225174)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.16888 0.16888) rotate(90) scale(0.225174)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.703037 0.703668) rotate(90) scale(0.938224 0.937383)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.468691 0.469112) rotate(90) scale(0.625483 0.624922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.468691 0.469112) rotate(90) scale(0.625483 0.624922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.468691 0.469112) rotate(90) scale(0.625483 0.624922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.234281 0.234281) rotate(90) scale(0.312375)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.234281 0.234281) rotate(90) scale(0.312375)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.283963 0.283963) rotate(90) scale(0.378617)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.141981 0.141981) rotate(90) scale(0.189308)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.141981 0.141981) rotate(90) scale(0.189308)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.302004 0.302004) rotate(90) scale(0.402672)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.302004 0.302004) rotate(90) scale(0.402672)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_2615_299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.515114 0.515443) rotate(90) scale(0.687257 0.686818)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_2615_299",
    x1: 251.837,
    y1: 40,
    x2: 251.837,
    y2: 108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EF2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_2615_299",
    x1: 171.221,
    y1: 74,
    x2: 332.454,
    y2: 74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19DCA1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#43FFC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D7656",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_2615_299",
    x1: 36.7772,
    y1: -0.31715,
    x2: 29.2232,
    y2: 19.6767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76FFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23CD9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_2615_299",
    x1: 44.4596,
    y1: 0.00000143546,
    x2: 49.2115,
    y2: 27.3361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0FFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1);
export default __webpack_public_path__ + "static/media/Frame1.9ffab82a20851dd631fb0f04139a47b5.svg";
export { ForwardRef as ReactComponent };